import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { APIService } from 'src/api/api';
import Loader from 'src/common/Loader';
import { setErrorInfo, setSuccessInfo } from 'src/redux/modalSlice';
import { DATE_FORMAT } from 'src/utils/constants';
import { getFormattedDate } from 'src/utils/getInitials';
import { getFormattedShiftDetails, getShiftDetails } from 'src/redux/settingSlice';
// import EditShiftModal from './EditShiftModal';

const SettingsNotifications = (props) => {
  const dispatch = useDispatch();
  const { loading, shiftLoaded, shiftLoading } = useSelector((state) => state.settings);
  const { appSettings } = useSelector((state) => state.settings);
  const shiftDetails = useSelector(getFormattedShiftDetails);
  const [isPreparingDemoTransactions, setIsPreparingDemoTransactions] = useState(false);
  const environmentName = appSettings?.environment?.toLowerCase();
  const showPrepareDemoButton = environmentName === 'development' || environmentName === 'dev';
  // const [openModal, setOpenModal] = useState(false);
  // const [currentShift, setCurrentShift] = useState();

  // const handleShiftEdit = (shift) => {
  //   setCurrentShift(shift);
  //   setOpenModal(true);
  // };

  // const closeModal = () => {
  //   setCurrentShift(null);
  //   setOpenModal(false);
  // };
  useEffect(() => {
    if (!shiftLoaded) {
      dispatch(getShiftDetails());
    }
  }, [dispatch, shiftLoaded]);

  const handlePrepareDemoTransactions = async () => {
    setIsPreparingDemoTransactions(true);
    try {
      const res = await APIService.prepareDemoTransactions();
      if (!res?.success) throw res;
      dispatch(setSuccessInfo({ successMsg: res?.message || 'Demo transactions prepared successfully!' }));
    } catch (error) {
      dispatch(setErrorInfo({ errorMsg: error?.error_message || 'Failed to prepare demo transactions.' }));
    } finally {
      setIsPreparingDemoTransactions(false);
    }
  };

  return (
    <form {...props}>
      <Card>
        <CardHeader
          subheader="Manage app settings"
          title="Settings"
        />
        <Divider />
        <CardContent>
          {loading || shiftLoading ? <Loader />
            : (
              <Grid container spacing={2}>
                <Grid item>
                  <Typography variant="h5" sx={{ py: 1, mb: 1, color: '#333' }}>Shift Details</Typography>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead sx={{ backgroundColor: 'lightgrey' }}>
                        <TableRow>
                          <TableCell>Shift Name</TableCell>
                          <TableCell>Shift Start</TableCell>
                          <TableCell>Shift End</TableCell>
                          {/* <TableCell>Action</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {shiftDetails?.map((shift) => (
                          <TableRow hover key={shift.id}>
                            <TableCell>{shift.name || 'NA'}</TableCell>
                            <TableCell>{getFormattedDate(shift.shift_starts_from, DATE_FORMAT.time)}</TableCell>
                            <TableCell>{getFormattedDate(shift.shift_end_time, DATE_FORMAT.time)}</TableCell>
                            {/* <TableCell>
                              <Button variant="outlined" size="small" onClick={() => handleShiftEdit(shift)}>
                                Edit
                              </Button>
                              <Button
                                color="primary"
                                size="small"
                                variant="contained"
                                sx={{ ml: 1 }}
                              >
                                Delete
                              </Button>
                            </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* <EditShiftModal open={openModal} initialValues={currentShift} handleClose={closeModal} /> */}
                </Grid>
                {showPrepareDemoButton && (
                  <Grid item xs={12}>
                    <Stack direction="row" justifyContent="flex-end">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handlePrepareDemoTransactions}
                        disabled={isPreparingDemoTransactions}
                        startIcon={isPreparingDemoTransactions ? <CircularProgress color="inherit" size={16} /> : null}
                      >
                        {isPreparingDemoTransactions ? 'Preparing...' : 'Prepare Demo Transactions'}
                      </Button>
                    </Stack>
                  </Grid>
                )}
              </Grid>
            )}
        </CardContent>
      </Card>
    </form>
  );
};

export default SettingsNotifications;
